module.exports = __webpack_public_path__ + "img/code-pc.08133e68.png";